import { render, staticRenderFns } from "./ventasacumuladascomercios.vue?vue&type=template&id=91bb6078"
import script from "./ventasacumuladascomercios.vue?vue&type=script&lang=js"
export * from "./ventasacumuladascomercios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports